import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询品牌类目
export const queryBrands: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setBrands', { ...state.brands, loading: true });
    const res = await $http.get('/v1/data/baseinfo/brand/list');
    commit('setBrands', { data: res });
  } catch (e) {
    commit('setBrands', { data: [] });
  }
};

// 查询后台模型类型
export const queryBackTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setBackTypes', { ...state.backTypes, loading: true });
    // const res = await $http.get(`/baseinfo/brand/type/get/${payload}`);
    const res = await $http.get('/common/chooseoptions/BackType');
    commit('setBackTypes', { data: res });
  } catch (e) {
    commit('setBackTypes', { data: [] });
  }
};

// 查询过滤项类型
export const queryFilterTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setFilterTypes', { ...state.filterTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/FilterItemType');
    commit('setFilterTypes', { data: res });
  } catch (e) {
    commit('setFilterTypes', { data: [] });
  }
};

// 查询实体类型
export const queryEntityTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setEntityTypes', { ...state.filterTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/FilterItemEntityType');
    commit('setEntityTypes', { data: res });
  } catch (e) {
    commit('setEntityTypes', { data: [] });
  }
};
